export default __webpack_public_path__ + "static/feature2-46c15699d3b9c76ffb94a24a46091932.webp";